
import Vue, { PropType } from 'vue';
import moment from 'moment';
import 'moment-timezone';

export default Vue.extend({
    name: 'DateRange',
    props: {
        start: {
            type: [String, Date] as PropType<string | Date>,
            required: true,
        },
        end: {
            type: [String, Date] as PropType<string | Date>,
            required: true,
        },
    },
    computed: {
        isOneDay(): boolean {
            if (!this.end) return true;
            let start = new Date(this.start);
            let end = new Date(this.end);

            return (
                start.getDate() === end.getDate() &&
                start.getMonth() === end.getMonth() &&
                start.getFullYear() === end.getFullYear()
            );
        },
        dateString(): string {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const start = moment(this.start || new Date()).tz(timeZone);
            const thisYear = start.isSame(moment().tz(timeZone), 'year');

            if (this.isOneDay) return start.format(thisYear ? 'D MMMM, LT z' : 'D MMMM YYYY, LT z');

            const end = moment(this.end).tz(timeZone);

            const sameYear = start.isSame(end, 'year');
            const showYear = !thisYear || !sameYear;

            const timeString = start.format('LT z');
            const startString = start.format(showYear ? 'D MMMM YYYY' : 'D MMMM');
            const endString = end.format(showYear ? 'D MMMM YYYY' : 'D MMMM');

            return `${startString} - ${endString}, ${timeString}`;
        },
    },
});
